export default __webpack_public_path__ + "static/media/film.5048a4c7.svg";